import { render } from "./AppGroupSelect.vue?vue&type=template&id=97497212"
import script from "./AppGroupSelect.vue?vue&type=script&lang=js"
export * from "./AppGroupSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__